<template>
    <div v-if="facility">
      <div class="overview-data">
        <el-card style="grid-column: 1 / 4" shadow="never"
          :body-style="{ background: 'linear-gradient(35deg, #0c3da7, #009aca)', height: '100%' }">
          <div class="wallet-balance">
          <h4 class="wallet-head">
            <i class="el-icon-wallet"></i>
            RS Wallet Balance
          </h4>
          <h1 class="wallet-text">
            {{ walletBalance }}
          </h1>
          <div class="wallet-balance-controls">
            <el-popover placement="top" trigger="hover"
              content="Add Money to customer account, any balance overdue will automatically get cleared." effect="light">
              <el-button round slot="reference" :type="styleForAddMoney" icon="el-icon-plus"
                :disabled="customerDetails.blockPayments" @click="openAddMoneyDialog">
              </el-button>
            </el-popover>
            <el-popover placement="top" trigger="hover" content="Refund Wallet Balance to Customer" effect="light">
              <el-button round slot="reference" :type="styleForAddMoney" icon="el-icon-refresh-right"
                :disabled="!refundable" @click="() => openPartialRefundDialog = true">
              </el-button>
            </el-popover>
            <el-popover placement="top" trigger="hover"
              content="Sync Money to customer wallet, any active lease due balance will be cleared." effect="light">
              <el-button round slot="reference" :type="styleForAddSync" icon="el-icon-refresh"
                :disabled="customerDetails.blockPayments" @click="syncMoney">
              </el-button>
            </el-popover>
          </div>
          </div>
        </el-card>
        <div style="display: flex; flex-direction: column; gap: 0.5rem; grid-column: 4 / 6">
          <DashboardHero shadow="never">
            <template v-slot:title>Account Balance:</template>
            <template v-slot:value>
              {{ accountBalance || 0 | currencySign }}
            </template>
          </DashboardHero>
          <DashboardHero shadow="never">
            <template v-slot:title>Past Due:</template>
            <template v-slot:value>
              {{ pastDue || 0 | currencySign }}
            </template>
          </DashboardHero>
          <DashboardHero shadow="never">
            <template v-slot:title>ACH Payments Pending:</template>
            <template v-slot:value>
              {{ achPending || 0 | currencySign }}
            </template>
          </DashboardHero>
          <DashboardHero shadow="never">
            <template v-slot:title>Security Deposit:</template>
            <template v-slot:value>
              {{ activeLease ? activeLease.depositPaid : 0 | currencySign }}
            </template>
          </DashboardHero>
        </div>
      </div>
      <el-dialog :visible.sync="openPartialRefundDialog">
        <CustomerPartialRefundRequest :customer="customerDetails._id" :facility="facility" :wallet="facilityAccount"
          @created="reloadAfterRRCreated">
        </CustomerPartialRefundRequest>
      </el-dialog>
      <el-dialog :visible.sync="addMoneyDialog" @close="clearFields" width="70%">
        <el-card>
          <template slot="header">
            <el-steps :active="addMoneyActive" align-center finish-status="success">
              <el-step title="Select Payment Mode"></el-step>
              <el-step title="Add Money to wallet"></el-step>
              <el-step title="Done" :status="paymentStatus"></el-step>
            </el-steps>
          </template>
          <el-form v-if="addMoneyActive === 0">
            <el-form-item label="Payment Mode">
              <el-select v-model="mode" placeholder="Select Payment Mode" @change="() => addMoneyActive = 1">
                <el-option v-for="item in modeOptions" :key="item.value" :label="item.label" :value="item.value"
                  :disabled="item.disabled">
                </el-option>
              </el-select>
            </el-form-item>
            <el-alert v-if="!allowAccess('level_3')">
              Level 4 user do not have the permissions for Credit without Payment
            </el-alert>
            <el-form-item v-if="mode">
              <el-button @click="() => addMoneyActive = 1">
                Next
              </el-button>
            </el-form-item>
          </el-form>
          <el-form v-if="addMoneyActive === 1 && mode === 'manual'" :model="newReceipt" ref="receipt" :rules="{}">
            <!-- <el-form-item label="Transaction No" prop="transaction" :rules="[
                { required: true, message: 'Please input payment no', trigger: 'blur' }
                ]">
                <el-input v-model="newReceipt.transaction">
                  <el-button slot="prepend" @click="() => newReceipt.transaction = generateRandomCode()">
                    Generate code
                  </el-button>
                </el-input>
              </el-form-item> -->
            <el-form-item label="Description" prop="description" :rules="[
              { required: true, message: 'Please add description', trigger: 'blur' }
            ]">
              <el-input v-model="newReceipt.details">
                <el-button v-if="customerHasDues" slot="prepend" @click="addDescription">
                  Due Amount: {{ accountBalance |
                    currencySign($root.state.facilityData) }}
                </el-button>
              </el-input>
            </el-form-item>
            <el-form-item label="Amount Paid" prop="amountPaid" :rules="[
              { required: true, message: 'Please input amount', trigger: 'blur' }
            ]">
              <el-popover trigger="hover">
                <div v-if="customerHasDues">
                  Due Amount: {{ accountBalance |
                    currencySign($root.state.facilityData) }}
                </div>
                <div v-else>
                  {{ noDueText() }}
                </div>
                <el-input-number slot="reference" :precision="2" :min="0" v-model="newReceipt.amountPaid"
                  @change="computeAmountDue">
                </el-input-number>
              </el-popover>
            </el-form-item>
            <!-- <el-form-item label="Upload attachments">
                <Upload listType="picture" @upload-completed="addImageToReceipt" />
              </el-form-item> -->
            <el-button plain type="warning" @click="() => addMoneyActive = 0">
              Back
            </el-button>
            <el-button @click="addReceipt">
              Add
            </el-button>
          </el-form>
          <el-form v-if="addMoneyActive === 1 && mode === 'cheque'" v-model="chequeTransaction">
            <el-form-item label="Cheque No">
              <el-input v-model="chequeTransaction.chequeNo">
              </el-input>
            </el-form-item>
            <el-form-item label="Cheque Deposit Date">
              <el-date-picker v-model="chequeTransaction.depositedAt" type="date">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="Amount Paid via Cheque">
              <el-input-number :precision="2" :min="0" v-model="chequeTransaction.amountPaid">
              </el-input-number>
            </el-form-item>
            <el-button plain type="warning" @click="() => addMoneyActive = 0">
              Back
            </el-button>
            <el-button @click="addChequeTransaction">
              Add
            </el-button>
          </el-form>
          <el-form v-if="addMoneyActive === 1 && mode === 'wire'" :model="wireTransaction" ref="wireTransactionRef">
            <el-form-item label="Verified By"
            :rules="[{
              required: true,
              message: 'Please add verified by.',
              trigger: 'blur',
            }]"
            prop="verifiedBy"
            >
              <el-input v-model="wireTransaction.verifiedBy">
              </el-input>
            </el-form-item>
            <el-form-item label="Wire Deposit Date">
              <el-date-picker v-model="wireTransaction.depositedAt" type="date">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="Amount Paid via Wire">
              <el-input-number :precision="2" :min="0" v-model="wireTransaction.amountPaid">
              </el-input-number>
            </el-form-item>

            <el-button plain type="warning" @click="() => addMoneyActive = 0">
              Back
            </el-button>
            <el-button @click="addWireTransaction">
              Add
            </el-button>
          </el-form>

          <el-form :model="transaction" v-if="addMoneyActive === 1 && mode === 'braintree'" style="width: 100%">
            <el-alert type="warning">
              <p style="text-align: left">
                ACH payments may take up to 3 business days to clear.
                They will not be reflected in the customer's account balance or as a completed payment during the
                settlement process.
                If a customer has a pending payment for their full balance due, they will not be charged late fee even if
                the clearing occurs after the late fee processing. <br />
                Upon successful clearing, the amount will be posted to the account automatically.

                <br /><br />
                <b>
                  Note: You will not be able to initiate a new license paid by ACH until the payment has cleared.
                </b>
              </p>
            </el-alert>
            <br />
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="Description" prop="description">
                  <el-input v-model="transaction.description"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="Payment Account">
                  <br />
                  <el-select style="display: block" v-model="selectedPaymentMethod"
                    placeholder="Select account in BrainTree" @change="selectPaymentMethod">
                    <el-option v-for="item in customer.paymentMethods" :key="item.last4" :value="item.last4"
                      :label="`${item.bankName || item.cardType} - ${item.last4}`"
                      :disabled="item.bankName && customerDetails.blockAchPayments">
                      <span>
                        <img :src="item.imageUrl" class="payment-image" />
                      </span>
                      <span>
                        <el-tag size="mini" effect="plain" v-if="item.bankName">
                          ACH
                        </el-tag>
                        <el-tag size="mini" effect="plain" v-else>
                          Credit Card
                        </el-tag>
                        <el-tag size="mini" v-if="item.bankName">
                          {{ item.bankName }}
                        </el-tag>
                        <el-tag size="mini" v-else>
                          {{ item.cardType }}
                        </el-tag>

                        <el-tag size="mini" type="success" v-if="item.default" effect="plain">
                          Primary
                        </el-tag>
                      </span>
                      <span>
                        <el-tag size="mini" type="info">
                          {{ item.last4 }}
                        </el-tag>
                      </span>
                      <span>
                        <el-tag size="mini" type="danger"
                          v-if="item.verified === false || item.verification && item.verification.status !== 'verified'">
                          NOT VERIFIED
                        </el-tag>
                        <el-tag size="mini" type="success"
                          v-if="item.verified === true || item.verification && item.verification.status === 'verified'">
                          VERIFIED
                        </el-tag>
                      </span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-form-item label="Amount" prop="amountPaid" :rules="[
                { required: true, message: 'Please input amount', trigger: 'blur' }
              ]">
                <br />
                <el-col :span="10" style="text-align: left;">
                  <el-select style="width: 100%" v-model="amountType" @change="setTransactionAmount"
                    placeholder="Select Amount Type">
                    <el-option :value="0" label="Past Due Minus Pending ACH (Primary)"></el-option>
                    <el-option :value="1" label="Account Balance Minus Pending ACH"></el-option>
                    <el-option :value="2" label="Custom Amount"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="6" style="text-align: left;">
                  <el-popover trigger="hover">
                    <div v-if="customerHasDues">
                      Due Amount: {{ accountBalance |
                        currencySign($root.state.facilityData) }}
                    </div>
                    <div v-else>
                      {{ noDueText() }}
                    </div>
                    <el-input-number style="width: 100%" :disabled="amountType !== 2" :controls="false" :precision="2"
                      :min="0" slot="reference" v-model="transaction.originalAmount" @blur="computeAmountDue">
                    </el-input-number>
                  </el-popover>
                </el-col>
                <el-col style="text-align: left" :span="6">
                  <el-checkbox v-model="waiveFee" @change="getCreditCardFee" label="Waive Credit Card fee" size="small"
                    v-if="creditCardSelected()" />
                </el-col>
              </el-form-item>
              <el-descriptions border :column="1" v-if="creditCardSelected()">
                <template slot="extra">
                </template>
                <el-descriptions-item label="Credit Card Fee">
                  {{
                    Number(getCreditCardFee()) | currencySign($root.state.facilityData)
                  }}
                </el-descriptions-item>
                <el-descriptions-item label="Total">
                  {{
                    transaction.amountPaid | currencySign($root.state.facilityData)
                  }}
                </el-descriptions-item>
              </el-descriptions>
              <el-divider></el-divider>
              <el-button plain type="warning" @click="() => addMoneyActive = 0">
                Back
              </el-button>
              <el-button :disabled="Number(transaction.originalAmount) === 0" @click="addTransaction">
                Pay
              </el-button>
            </el-row>
          </el-form>

          <el-result v-if="addMoneyActive === 2 && moneyAddedStatus && !loading" icon="success" title="Successfully Charged"
            subTitle="">
          </el-result>
          <el-card :span="6" v-else-if="addMoneyActive === 2 && !moneyAddedStatus && loading">
            Processing
          </el-card>
          <el-card :span="6" v-else-if="addMoneyActive === 2 && moneyAddedStatus && loading">
            Almost done
          </el-card>
          <el-result v-else-if="addMoneyActive === 2 && !moneyAddedStatus && !loading"
            :icon="changeIcon ? 'warning' : 'error'"
            :title="transactionMessage ? transactionMessage : 'Something went wrong'" subTitle="">
            <template slot="extra">
              <el-button v-if="transactionMessage === 'Settlement Pending'" @click="() => addMoneyDialog = false">
                Done
              </el-button>
              <el-button v-else type="warning" @click="() => addMoneyActive = 1">
                Back
              </el-button>
            </template>
          </el-result>
        </el-card>
      </el-dialog>
    </div>
    <div v-else>
      <no-site-map />
    </div>
</template>

<script>
import axios from 'axios';
import { CUSTOMER_API_BASE, FACILITY_ACCOUNT_API_BASE, PG_API_BASE, FACILITY_TRANSACTIONS_API_BASE, LEASING_API } from '../env';
import NoSiteMap from './NoSiteMap';
import Upload from './Uploader';
import { allowAccess } from '../utils/roles';
import { getFacility } from '../utils/commonApi';
import CustomerPartialRefundRequest from './CustomerPartialRefundRequest';
import DashboardHero from './DashboardHero';

export default {
  name: 'CustomerOverview',
  components: {
    DashboardHero,
    NoSiteMap,
    Upload,
    CustomerPartialRefundRequest,
  },
  props: {
    customerDetails: { type: Object, required: true },
    facility: { type: String },
    reload: { type: Boolean, default: false },
  },
  computed: {
    accountBalance() {
      return this.facilityAccount.totalDueAmount;
      // if (this.activeLease) {
      //   return this.activeLease.amount - this.activeLease.amountPaid;
      // }

      // const pastLeasesAmount = this.pastLeases
      //   .map(lease => lease.amount).reduce((p, n) => p + n, 0);
      // const pastLeasesAmountPaid = this.pastLeases
      //   .map(lease => lease.amountPaid).reduce((p, n) => p + n, 0);
      // return pastLeasesAmount - pastLeasesAmountPaid;
    },
    pastDue() {
      if (this.activeLease) {
        if (!this.activeLease.amountToBePaid) {
          return 0;
        }
        return this.activeLease.amountToBePaid - this.activeLease.amountPaid > 0
          ? this.activeLease.amountToBePaid - this.activeLease.amountPaid : 0;
      }

      return this.accountBalance;
    },
    activeLease() {
      const [aLease] = this.leases.filter(lease => lease && !lease.future);
      return aLease;
    },
    refundable() {
      return this.facilityAccount.amount < this.facilityAccount.amountPaid;
    },
    styleForAddMoney() {
      if (this.customerHasDues) {
        return 'danger';
      }
      return 'success';
    },
    styleForAddSync() {
      if (this.customerHasDues) {
        return 'danger';
      }
      return 'success';
    },
    customerHasDues() {
      return this.accountBalance > 0;
    },
    revenue() {
      if (this.activeLease && this.activeLease.amountPaid && this.activeLease.depositPaid) {
        return this.activeLease.amountPaid - this.activeLease.depositPaid;
      }
      return 0;
    },
    securityDeposit() {
      const { deposit, amountPaid } = this.facilityAccount;
      if (deposit > 0 && amountPaid >= deposit) {
        return this.$options.filters.currencySign(Number(deposit), this.$root.state.facilityData);
      }
      return this.$options.filters.currencySign(Number(0), this.$root.state.facilityData);
    },
    walletBalance() {
      if (!this.facilityAccount || !this.facilityAccount.wallet) {
        return this.$options.filters.currencySign(Number(0), this.$root.state.facilityData);
      }
      return this.$options.filters.currencySign(Number(this.facilityAccount.wallet), this.$root.state.facilityData);
    },
    modeOptions() {
      return [
        {
          value: 'braintree',
          label: 'Credit Card or ACH',
          disabled: this.customer && this.customer.paymentMethods.length === 0,
        },
        {
          value: 'cheque',
          label: 'Cheque',
          disabled: this.customerDetails.blockChequePayments,
        },
        {
          value: 'wire',
          label: 'Wire',
        },
        {
          value: 'manual',
          label: 'Credit without Payment',
          disabled: !allowAccess('level_3', this.$keycloak, this.$root.state.facility),
        },
      ];
    },
    paymentStatus() {
      if (this.addMoneyActive < 2) {
        return 'wait';
      }

      if (this.moneyAddedStatus) {
        return 'success';
      }

      return 'process';
    },
  },
  data() {
    return {
      selectedPaymentMethod: null,
      amountType: null,
      achPending: 0,
      customer: null,
      changeIcon: false,
      addMoneyDialog: false,
      facilityAccountExists: false,
      moneyAddedStatus: false,
      facilityAccount: {},
      addMoneyActive: 0,
      mode: null,
      facilityData: {},
      transactionMessage: '',
      waiveFee: false,
      openPartialRefundDialog: false,
      newReceipt: {
        transaction: '',
        details: '',
        url: '',
        amountPaid: 0,
        amountDue: 0,
      },
      wireTransaction: {
        verifiedBy: '',
        depositedAt: new Date(),
        transaction: this.generateRandomCode(),
        url: '',
        amountPaid: 0,
        amountDue: 0,
      },
      chequeTransaction: {
        chequeNo: '',
        depositedAt: new Date(),
        transaction: this.generateRandomCode(),
        url: '',
        amountPaid: 0,
        amountDue: 0,
      },
      transaction: {
        transaction: '',
        details: '',
        url: '',
        amountPaid: 0,
        amountDue: 0,
        originalAmount: 0,
        selectedPaymentMethod: null,
      },
      account: 0,
      amountPaid: 0,
      loading: false,
      percentage: 0,
      leases: [],
      pastLeases: [],
    };
  },
  async mounted() {
    if (!this.facility) { return; }

    this.fetchData();
  },
  watch: {
    customerDetails() {
      if (this.addMoneyDialog) { return; }

      this.fetchData();
    },
    reload() {
      this.fetchData();
    },
    facility() {
      if (!this.facility) { return; }

      this.fetchData();
    },
  },
  methods: {
    creditCardSelected() {
      if (!this.transaction.selectedPaymentMethod) {
        return false;
      }
      const cardTokens = this.customer.creditCards.map(card => card.token);
      return cardTokens.includes(this.transaction.selectedPaymentMethod.token);
    },
    openAddMoneyDialog() {
      this.getCustomerFromBraintree();
      this.addMoneyDialog = true;
    },
    selectPaymentMethod(last4) {
      const method = this.customer.paymentMethods.find(method => method.last4 === last4);
      this.transaction.selectedPaymentMethod = method;
    },
    setTransactionAmount(amountType) {
      switch (amountType) {
        case 0: this.transaction.originalAmount = (this.pastDue - this.achPending) || 0;
          break;
        case 1: this.transaction.originalAmount = (this.accountBalance - this.achPending) || 0;
          break;
        case 2:
        default: this.transaction.originalAmount = 0;
      }
    },
    async fetchData() {
      await Promise.all([
        this.getCustomerFacilityAccount(),
        this.getCustomerInvoices(),
        this.getCustomerFromBraintree(),
        this.getACHPendingTransactions(),
        this.getFacility(),
      ]);
    },
    async reloadAfterRRCreated() {
      this.openPartialRefundDialog = false;
      await this.syncMoney();
    },
    allowAccess(role) {
      return allowAccess(role, this.$keycloak, this.$root.state.facility);
    },
    noDueText() {
      if (this.mode === 'braintree') {
        return `No overdue balance. Adding ${this.$options.filters.currencySign(Number(this.transaction.originalAmount), this.$root.state.facilityData)} goes to customer wallet.`;
      }
      return `No overdue balance. Adding ${this.$options.filters.currencySign(Number(this.newReceipt.amountPaid), this.$root.state.facilityData)} goes to customer wallet.`;
    },
    computeAmountDue() {
      if (this.mode === 'manual') {
        if (this.customerHasDues) {
          this.amountDueText = `Due Amount: ${this.$options.filters.currencySign(Number(this.accountBalance), this.$root.state.facilityData)}`;
        }
        this.newReceipt.amountDue = Number(this.account - this.amountPaid);
      } else {
        if (this.customerHasDues) {
          this.amountDueText = `Due Amount: ${this.$options.filters.currencySign(Number(this.activeLease.amount - this.activeLease.amountPaid), this.$root.state.facilityData)}`;
        }
        this.transaction.amountDue = Number(this.account - this.amountPaid);
      }
      if (!this.customerHasDues) {
        this.amountDueText = this.noDueText();
      }
    },
    async getCustomerFromBraintree() {
      try {
        const response = await axios.get(`${PG_API_BASE}/customer/${this.customerDetails._id}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.customer = response.data.customer;
      } catch (err) {
        this.customer = null;
      }
    },
    async getFacility() {
      const facilityData = await getFacility(this.facility, {
        token: this.$keycloak.token,
      });
      this.facilityData = facilityData;
    },
    getCreditCardFee() {
      if (this.creditCardSelected()) {
        if (
          this.facilityData.creditCardFee
          && this.facilityData.creditCardFee.enabled && !this.waiveFee
        ) {
          this.transaction.amountPaid = (
            this.transaction.originalAmount
            + (this.transaction.originalAmount
              * (this.facilityData.creditCardFee.fee / 100)
            )
          );

          return Number(Number((this.transaction.originalAmount
            * (this.facilityData.creditCardFee.fee / 100)
          )).toFixed(2));
        }

        this.transaction.amountPaid = this.transaction.originalAmount;
        return 0;
      }

      return 0;
    },
    async createInitialFacilityPGTransaction() {
      const pgfacilityAccountTransaction = {
        createdAt: new Date(),
        facility: this.facility,
        customer: this.customerDetails._id,
        source: this.transaction.selectedPaymentMethod.last4,
        type: this.creditCardSelected() ? 'CREDIT_CARD' : 'ACH',
        ...(this.creditCardSelected()
          ? {
            enabledCreditCardFee: (
              this.facilityData.creditCardFee && this.facilityData.creditCardFee.enabled && !this.waiveFee
            ),
          } : {}),
        ...(
          this.creditCardSelected() &&
            this.facilityData.creditCardFee &&
            this.facilityData.creditCardFee.enabled &&
            !this.waiveFee ?
            {
              creditCardFee: this.getCreditCardFee(),
            } : {}),
        details: this.transaction.description,
        createdBy: this.$keycloak.tokenParsed.email,
        amount: this.transaction.originalAmount,
      };
      const { data } = await axios.post(`${FACILITY_TRANSACTIONS_API_BASE}/v1/${this.facility}/transaction/initiate/pg`, {
        ...pgfacilityAccountTransaction,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      return data.result.transaction;
    },
    async syncMoney() {
      this.loading = true;
      await axios.get(`${FACILITY_ACCOUNT_API_BASE}/v1/${this.facility}/${this.customerDetails._id}/sync`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      await this.getCustomerFacilityAccount();
      await this.getCustomerInvoices();
      this.$emit('update');
      this.loading = false;
    },
    async updateFacilityAccountTransactionWithBraintree(braintreeTransaction, facilityTransaction) {
      const response = await axios.put(`${FACILITY_TRANSACTIONS_API_BASE}/v1/${facilityTransaction.id}`, {
        pgTransaction: braintreeTransaction,
        transactionUpdate: facilityTransaction,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      return response.data;
    },
    clearFields() {
      this.newReceipt = {
        transaction: '',
        details: '',
        url: '',
        amountPaid: 0,
        amountDue: 0,
      };

      this.transaction = {
        transaction: '',
        details: '',
        url: '',
        amountPaid: 0,
        amountDue: 0,
        originalAmount: 0,
      };

      this.mode = '';
      this.addMoneyActive = 0;
      this.moneyAddedStatus = false;
      this.amountType = 0;
      this.selectedPaymentMethod = null;
    },
    async cwwFacilityTransaction(transaction) {
      const { data } = await axios.post(`${FACILITY_TRANSACTIONS_API_BASE}/v1/${this.facility}/transaction/initiate/cww`, {
        ...transaction,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      return data.result.transaction;
    },
    async getACHPendingTransactions() {
      const { data } = await axios.get(`${FACILITY_TRANSACTIONS_API_BASE}/v1/${this.facility}/${this.customerDetails._id}/pending/ach`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.achPending = data.result.transactions
        .filter(transaction => transaction.events && transaction.events[transaction.events.length - 1].status !== 'failed')
        .map(item => item.amount).reduce((pv, nx) => pv + nx, 0);
      return this.achPending;
    },
    async addChequeTransaction() {
      try {
        if (this.chequeTransaction.amountPaid === 0) {
          this.$message.error({
            title: 'Validation Error',
            message: 'Amount should be greater than 0.',
          });
          return;
        }

        if (this.customerDetails.blockChequePayments) {
          this.$message.error({
            title: 'Blocked Payments',
            message: 'Cheque payments are blocked',
          });
        }

        this.loading = true;
        this.addMoneyActive += 1;

        // eslint-disable-next-line no-nested-ternary
        this.chequeTransaction.amountDue = !this.facilityAccountExists ? 0
          : this.facilityAccount.amount > (this.chequeTransaction.amountPaid + this.facilityAccount.amountPaid)
            ? this.facilityAccount.amount - (this.chequeTransaction.amountPaid + this.facilityAccount.amountPaid)
            : 0;

        if (this.facilityAccountExists && this.facilityAccount.chequeTransactions) {
          this.facilityAccount.chequeTransactions.push(this.chequeTransaction);
        }

        if (!this.facilityAccountExists) {
          const result = await axios.post(`${FACILITY_ACCOUNT_API_BASE}/v1/account`, {
            chequeTransactions: [this.chequeTransaction],
            amount: 0,
            amountPaid: this.chequeTransaction.amountPaid,
            facility: this.facility,
            customer: this.customerDetails._id,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
          this.facilityAccountExists = true;
          this.facilityAccount = result.data;
        } else {
          await axios.put(`${FACILITY_ACCOUNT_API_BASE}/v1/${this.facility}/${this.customerDetails._id}`, {
            chequeTransactions: this.facilityAccount.chequeTransactions,
            amountPaid: Number(this.facilityAccount.amountPaid + this.chequeTransaction.amountPaid),
          },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
        }

        await this.cwwFacilityTransaction({
          facility: this.facility,
          customer: this.customerDetails._id,
          facilityAccount: this.facilityAccount._id,
          ...(this.activeLease && this.activeLease.amount > this.activeLease.amountPaid ? {
            invoice: this.activeLease._id,
          } : {}),
          details: `${this.chequeTransaction.chequeNo}`,
          amount: this.chequeTransaction.amountPaid,
          amountPaid: this.chequeTransaction.amountPaid,
          depositedAt: this.chequeTransaction.depositedAt,
          createdBy: this.$keycloak.tokenParsed.email,
          createdAt: new Date(),
          source: this.chequeTransaction.chequeNo,
          success: true,
          type: 'CHEQUE',
        });

        this.moneyAddedStatus = true;
        await this.syncMoney();
        await this.getCustomerFacilityAccount();
        await this.getCustomerInvoices();

        this.loading = false;
        this.$message.success({
          title: 'Success',
          message: 'Amount added successfully.',
        });
        this.$emit('update');
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.moneyAddedStatus = false;
        this.$message.error({
          title: 'Error',
          // eslint-disable-next-line no-nested-ternary
          message: typeof err === 'string' ? err : err.message ? err.message : err.response.data,
        });
      }
    },
    async addWireTransaction() {
      try {
        if (!this.wireTransaction.verifiedBy) {
          this.$message.error({
            title: 'Validation Error',
            message: 'Verified by is required.',
          });

          return;
        }
        if (Number.isNaN(this.wireTransaction.amountPaid)) {
          this.$message.error({
            title: 'Validation Error',
            message: 'Amount should be a valid number.',
          });

          return;
        }
        if (this.wireTransaction.amountPaid === 0) {
          this.$message.error({
            title: 'Validation Error',
            message: 'Amount should be greater than 0.',
          });

          return;
        }

        this.loading = true;
        this.addMoneyActive += 1;

        // eslint-disable-next-line no-nested-ternary
        this.wireTransaction.amountDue = !this.facilityAccountExists ? 0
          : this.facilityAccount.amount > (this.wireTransaction.amountPaid + this.facilityAccount.amountPaid)
            ? this.facilityAccount.amount - (this.wireTransaction.amountPaid + this.facilityAccount.amountPaid)
            : 0;

        if (this.facilityAccountExists && this.facilityAccount.wireTransactions) {
          this.facilityAccount.wireTransactions.push(this.wireTransaction);
        }

        if (!this.facilityAccountExists) {
          const result = await axios.post(`${FACILITY_ACCOUNT_API_BASE}/v1/account`, {
            wireTransactions: [this.wireTransaction],
            amount: 0,
            amountPaid: this.wireTransaction.amountPaid,
            facility: this.facility,
            customer: this.customerDetails._id,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
          this.facilityAccountExists = true;
          this.facilityAccount = result.data;
        } else {
          await axios.put(`${FACILITY_ACCOUNT_API_BASE}/v1/${this.facility}/${this.customerDetails._id}`, {
            wireTransactions: this.facilityAccount.wireTransactions,
            amountPaid: Number(this.facilityAccount.amountPaid + this.wireTransaction.amountPaid),
          },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
        }

        await this.cwwFacilityTransaction({
          facility: this.facility,
          customer: this.customerDetails._id,
          facilityAccount: this.facilityAccount._id,
          ...(this.activeLease && this.activeLease.amount > this.activeLease.amountPaid ? {
            invoice: this.activeLease._id,
          } : {}),
          details: `Verified By: ${this.wireTransaction.verifiedBy}`,
          amount: this.wireTransaction.amountPaid,
          amountPaid: this.wireTransaction.amountPaid,
          depositedAt: this.wireTransaction.depositedAt,
          verifiedBy: this.wireTransaction.verifiedBy,
          createdBy: this.$keycloak.tokenParsed.email,
          createdAt: new Date(),
          success: true,
          type: 'WIRE',
        });

        this.moneyAddedStatus = true;
        await this.syncMoney();
        await this.getCustomerFacilityAccount();
        await this.getCustomerInvoices();

        this.loading = false;
        this.$message.success({
          title: 'Success',
          message: 'Amount added successfully.',
        });
        this.$emit('update');
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.moneyAddedStatus = false;
        this.$message.error({
          title: 'Error',
          // eslint-disable-next-line no-nested-ternary
          message: typeof err === 'string' ? err : err.message ? err.message : err.response.data,
        });
      }
    },
    async addReceipt() {
      if (!this.newReceipt.details) {
        this.$message.error({
          title: 'Validation Error',
          message: 'Please add the description for the transaction.',
        });
        return;
      }

      if (this.newReceipt.amountPaid === 0) {
        this.$message.error({
          title: 'Validation Error',
          message: 'Amount should be greater than 0.',
        });
        return;
      }
      this.loading = true;
      this.addMoneyActive += 1;

      try {
        // eslint-disable-next-line no-nested-ternary
        this.newReceipt.amountDue = !this.facilityAccountExists ? 0
          : this.facilityAccount.amount > (this.newReceipt.amountPaid + this.facilityAccount.amountPaid)
            ? this.facilityAccount.amount - (this.newReceipt.amountPaid + this.facilityAccount.amountPaid)
            : 0;
        if (this.facilityAccountExists && this.facilityAccount.receipts) {
          this.facilityAccount.receipts.push(this.newReceipt);
          this.facilityAccount.amountPaid = Number(this.facilityAccount.amountPaid) + Number(this.newReceipt.amountPaid);
        }


        if (!this.facilityAccountExists) {
          const response = await axios.post(`${FACILITY_ACCOUNT_API_BASE}/v1/account`, {
            receipts: [this.receipt],
            amount: 0,
            amountPaid: this.facilityAccount.amountPaid,
            facility: this.facility,
            customer: this.customerDetails._id,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
          this.facilityAccountExists = true;
          this.facilityAccount = response.data;
        } else {
          await axios.put(`${FACILITY_ACCOUNT_API_BASE}/v1/${this.facility}/${this.customerDetails._id}`, {
            receipts: this.facilityAccount.receipts,
            amountPaid: this.facilityAccount.amountPaid,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
        }

        await this.cwwFacilityTransaction({
          facility: this.facility,
          customer: this.customerDetails._id,
          facilityAccount: this.facilityAccount._id,
          ...(this.activeLease && this.activeLease.amount > this.activeLease.amountPaid ? {
            invoice: this.activeLease._id,
          } : {}),
          details: `${this.newReceipt.details}`,
          amount: this.newReceipt.amountPaid,
          amountPaid: this.newReceipt.amountPaid,
          createdBy: this.$keycloak.tokenParsed.email,
          createdAt: new Date(),
          success: true,
          type: 'CREDIT_WITHOUT_PAYMENT',
        });

        this.moneyAddedStatus = true;
        await this.syncMoney();
        await this.getCustomerFacilityAccount();

        await this.getCustomerInvoices();

        this.loading = false;
        this.$emit('update');
        this.$message.success({
          title: 'Success',
          message: 'Amount added successfully.',
        });
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.moneyAddedStatus = false;
        this.$notify.error({
          title: 'Error',
          // eslint-disable-next-line no-nested-ternary
          message: typeof err === 'string' ? err : err.message ? err.message : err.response.data,
        });
      }
    },
    async addTransaction() {
      try {
        if (this.transaction.originalAmount === 0) {
          this.$message.error({
            title: 'Validation Error',
            message: 'Amount should be greater than 0.',
          });
          return;
        }

        if (!this.transaction.selectedPaymentMethod) {
          this.$message.error({
            title: 'Payment',
            message: 'Please select a payment method',
          });
          return;
        }

        if (!this.creditCardSelected() && this.customerDetails.blockAchPayments) {
          this.$message.error({
            title: 'Blocked Payments',
            message: 'ACH payments are blocked',
          });

          return;
        }

        this.loading = true;
        this.addMoneyActive += 1;

        let pgInitialTransaction = null;

        pgInitialTransaction = await this.createInitialFacilityPGTransaction();

        const response = await axios.post(`${PG_API_BASE}/customer/transaction/create`, {
          paymentMethodToken: this.transaction.selectedPaymentMethod.token,
          customFields: {
            transaction: pgInitialTransaction.id,
          },
          customerId: this.customerDetails._id,
          ...(this.facilityData.merchant && this.facilityData.merchant.merchantId ?
            { merchantAccountId: this.facilityData.merchant.merchantId }
            : {}),
          amount: Math.round(
            Number((this.transaction.originalAmount + this.getCreditCardFee()) * 100),
          ) / 100,
          options: {
            submitForSettlement: true,
          },
        }, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });

        pgInitialTransaction = await this.updateFacilityAccountTransactionWithBraintree(response.data.result, pgInitialTransaction);

        if (!response.data.result.success) {
          this.$message({
            type: 'error',
            message: response.data.result.message,
          });
          this.loading = false;
          this.moneyAddedStatus = false;
          this.transactionMessage = response.data.result.message;
          this.$emit('update');
          return;
        }

        if (this.mode === 'braintree' && !this.creditCardSelected()) {
          if (response.data.result.transaction.status === 'settlement_pending') {
            this.$message.warning({
              title: 'Pending',
              message: 'When amount is settled it will be reflected on the wallet',
            });
            this.loading = false;
            this.moneyAddedStatus = false;
            this.transactionMessage = 'Settlement Pending';
            this.changeIcon = true;
            this.$emit('update');
            return;
          }
        }

        if (response.data.result.success) {
          this.transaction.transaction = response.data.result.transaction.id;
        }

        // eslint-disable-next-line no-nested-ternary
        this.transaction.amountDue = !this.facilityAccountExists ? 0
          : this.facilityAccount.amount > (this.transaction.originalAmount + this.facilityAccount.amountPaid)
            ? this.facilityAccount.amount - (this.transaction.originalAmount + this.facilityAccount.amountPaid)
            : 0;

        if (this.facilityAccountExists && this.facilityAccount.transactions) {
          this.facilityAccount.transactions.push(this.transaction);
        }

        if (!this.facilityAccountExists) {
          const result = await axios.post(`${FACILITY_ACCOUNT_API_BASE}/v1/account`, {
            transactions: [this.transaction],
            amount: 0,
            amountPaid: this.transaction.originalAmount,
            facility: this.facility,
            customer: this.customerDetails._id,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
          this.facilityAccountExists = true;
          this.facilityAccount = result.data;
        } else {
          await axios.put(`${FACILITY_ACCOUNT_API_BASE}/v1/${this.facility}/${this.customerDetails._id}`, {
            transactions: this.facilityAccount.transactions,
            amountPaid: Number(this.facilityAccount.amountPaid + this.transaction.originalAmount),
          },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
        }

        this.moneyAddedStatus = true;
        this.$message.success({
          title: 'Success',
          message: 'Amount added successfully.',
        });

        await this.syncMoney();
        await this.getCustomerFacilityAccount();
        await this.getCustomerInvoices();

        this.loading = false;
        this.$emit('update');
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.moneyAddedStatus = false;
        this.$message.error({
          title: 'Error',
          // eslint-disable-next-line no-nested-ternary
          message: typeof err === 'string' ? err : err.message ? err.message : err.response.data,
        });
      }
    },
    formatDue() {
      const due = this.account - this.amountPaid || 0;
      const dueAmount = this.$options.filters.currencySign(Number(due), this.$root.state.facilityData);
      return `Dues: ${dueAmount}`;
    },
    formatPaid() {
      const paidAmount = this.$options.filters.currencySign(Number(this.achPending), this.$root.state.facilityData);
      return `ACH Payments Pending: ${paidAmount}`;
    },
    generateRandomCode() {
      const code = `RS-${(+new Date()).toString(36).slice()}`;
      return code;
    },
    async getCustomerInvoices() {
      if (!this.facility || !this.customerDetails._id) {
        this.account = 0;
        this.amountPaid = 0;
        this.accountPercentage = 0;
        this.percentage = 0;
        return;
      }

      const response = await axios.get(`${CUSTOMER_API_BASE}/customers/v1/customer/invoices/${this.customerDetails._id}`, {
        params: {
          facility: this.facility,
        },
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.leases = response.data;
      if (response.data && !response.data.length) {
        await this.getCustomerPastLeases();
      }
      [this.activeLease] = response.data && response.data.length > 0 ? response.data.filter(item => item && !item.future) : [{}];
      if (this.activeLease) {
        this.account = this.activeLease.amount || 0;
        this.amountPaid = this.activeLease.amountPaid || 0;
        this.accountPercentage = Number(this.account * 100).toFixed(2) || 0;
        this.percentage = Number((this.account - this.amountPaid) / 100).toFixed(2) || 0;
      }
    },
    async getCustomerFacilityAccount() {
      if (!this.facility || !this.customerDetails._id) {
        this.facilityAccountExists = false;
        this.facilityAccount = { wallet: 0, amount: 0, amountPaid: 0, deposit: 0, depositToBeRefunded: 0 };
        return;
      }
      try {
        const response = await axios.get(`${FACILITY_ACCOUNT_API_BASE}/v1/${this.facility}/${this.customerDetails._id}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });

        if (!response.data) {
          await axios.post(`${FACILITY_ACCOUNT_API_BASE}/v1/account`, {
            transactions: [this.transaction],
            amount: 0,
            amountPaid: this.transaction.originalAmount,
            facility: this.facility,
            customer: this.customerDetails._id,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });

          this.facilityAccountExists = true;
          this.facilityAccount = response.data;
          this.$emit('account', response.data);
        }

        if (response.data) {
          this.facilityAccountExists = true;
          this.facilityAccount = response.data;
          this.$emit('account', response.data);
        }

        if (this.facilityAccount.amount || this.facilityAccount.amountPaid) {
          this.facilityAccount.wallet = this.facilityAccount.amountPaid - this.facilityAccount.amount;
          return;
        }
        // this.facilityAccount.wallet = this.facilityAccount.amountPaid && this.facilityAccount.amount >= 0 ? this.facilityAccount.amountPaid - this.facilityAccount.amount : 0;
      } catch (err) {
        this.facilityAccountExists = false;
        this.facilityAccount = { wallet: 0, amount: 0, amountPaid: 0, deposit: 0, depositToBeRefunded: 0 };
        this.$message({
          showClose: true,
          offset: 60,
          type: 'info',
          duration: 10000,
          message: 'Customer Facility Account not found! Add balance / Rent unit within the selected facility to create it.',
        });
      }
    },
    addImageToReceipt(url) {
      this.newReceipt.url = url;
    },
    addDescription() {
      if (this.mode === 'manual') {
        this.newReceipt.details = `Due Amount: ${this.$options.filters.currencySign(Number(this.account - this.amountPaid), this.$root.state.facilityData)}`;
      } else {
        this.transaction.details = `Due Amount: ${this.$options.filters.currencySign(Number(this.account - this.amountPaid), this.$root.state.facilityData)}`;
      }
      return `Due Amount: ${this.account - this.amountPaid}`;
    },
    async getCustomerPastLeases() {
      const response = await axios.get(`${LEASING_API}/v1/${this.facility}/${this.customerDetails._id}/past/lease`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.pastLeases = response.data;
    },
  },
};
</script>

<style scoped>
.wallet {
  width: 480px;
}

.wallet-text {
  color: #efefef;
  font-size: 1.75rem;
  margin: 0;
  font-weight: 900;
}

.wallet-head {
  font-weight: 500;
  margin: 0;
  font-family: sans-serif !important;
  color: #fff;
}

.card {
  margin-bottom: 20px;
}

.payment-image {
  vertical-align: middle;
  width: 40px;
}

.el-radio {
  margin: 0.5rem 0;
}

.overview-data {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.wallet-balance {
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
}

@media (min-width: 768px) {
  .wallet-balance-controls {
    grid-row: 1 / 3;
    grid-column: 5 / 6;
    display: flex;
    flex-direction: column;
    text-align: right;
    justify-content: space-between;
  }

  .wallet-head {
    grid-column: 1 / 5;
    align-self: center;
    text-align: left;
    grid-row: 1 / 2;
    font-size: 1.25rem;
  }

  .wallet-text {
    font-weight: 900;
    font-size: 3rem;
    grid-row: 2 / 3;
    grid-column: 1 / 5;
    text-align: left;
  }

  .overview-data {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
  }

  .wallet-balance {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: 1fr 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomerOverview.vue